// // src/pages/Login.jsx
// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../contexts/AuthContext';
// import axios from 'axios';
// import NotificationToast from '../components/NotificationToast';
// import { useTheme } from '../contexts/ThemeContext';

// const Login = ({ onLoginSuccess }) => {
//   const { user, login } = useAuth();
//   const { setTheme } = useTheme();
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [rememberMe, setRememberMe] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState(null);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!email || !password) {
//       setToast({ message: 'Please enter both email and password.', type: 'error' });
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await axios.post('/EOP_api/api/auth/login', {
//         email,
//         password
//       });

//       if (response.data && response.data.token) {
//         setTheme('light');
//         login(response.data.token, response.data.user);
//         setToast({ message: 'Login successful! Redirecting...', type: 'success' });
//         if (rememberMe) {
//           localStorage.setItem('remembered_email', email);
//         } else {
//           localStorage.removeItem('remembered_email');
//         }
//       }
//     } catch (err) {
//       setToast({
//         message: err.response?.data?.error || 'Invalid credentials or connection error.',
//         type: 'error'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const savedEmail = localStorage.getItem('remembered_email');
//     if (savedEmail) {
//       setEmail(savedEmail);
//       setRememberMe(true);
//     }
//   }, []);

//   return (
//     <div data-theme="dark" style={{ display: 'flex', minHeight: '100vh', width: '100vw', backgroundColor: 'var(--bg-primary)', overflow: 'hidden' }}>
//       {/* Left side: Premium Image Banner */}
//       <div
//         style={{
//           flex: '1',
//           background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.94), rgba(219, 39, 119, 0.85)), url("/onboarding_bg.png") center/cover no-repeat',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           padding: '4rem',
//           color: '#ffffff',
//           position: 'relative',
//           overflow: 'hidden'
//         }}
//         className="login-banner"
//       >
//         <div style={{ position: 'relative', zIndex: 2, maxWidth: '520px' }}>
//           <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '3rem', fontWeight: 800, lineHeight: 1.15, marginBottom: '1.5rem', textShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
//             Welcome to the Genesis Tech Engineers!
//           </h1>
//           <p style={{ fontSize: '1.1rem', lineHeight: 1.6, color: 'rgba(255, 255, 255, 0.95)', textShadow: '0 2px 6px rgba(0,0,0,0.1)', fontWeight: 400 }}>
//             Complete your self-onboarding tasks securely using the temporary credentials sent to your welcome email. Set up direct deposits, select benefits, sign tax forms, and register your profile.
//           </p>
//         </div>
//         {/* Soft background light glow overlay */}
//         <div style={{ position: 'absolute', bottom: '-20%', right: '-20%', width: '600px', height: '600px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)' }}></div>
//       </div>

//       {/* Right side: Login Form Card */}
//       <div
//         style={{
//           width: '500px',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           padding: '3rem 2.5rem',
//           backgroundColor: 'var(--bg-secondary)',
//           borderLeft: '1px solid var(--border-color)',
//           boxShadow: 'var(--shadow-lg)',
//           zIndex: 10
//         }}
//         className="login-form-container"
//       >
//         <div
//           style={{
//             width: '100%',
//             maxWidth: '360px',
//             animation: 'fadeIn var(--transition-normal) forwards'
//           }}
//         >
//           <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
//             <div
//               style={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: '54px',
//                 height: '54px',
//                 borderRadius: 'var(--border-radius-md)',
//                 background: 'linear-gradient(135deg, var(--primary), var(--accent))',
//                 color: '#ffffff',
//                 marginBottom: '1.25rem',
//                 boxShadow: '0 4px 12px rgba(99, 102, 241, 0.2)'
//               }}
//             >
//               <svg style={{ width: '28px', height: '28px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
//               </svg>
//             </div>
//             <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.75rem', fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text-primary)' }}>GTELINQ</h2>
//             <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: '0.25rem' }}>Employee Onboarding Portal</p>
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="form-group">
//               <label className="form-label" htmlFor="email-input">Corporate / Personal Email</label>
//               <input
//                 id="email-input"
//                 type="email"
//                 className="form-control"
//                 placeholder="name@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//             </div>

//             <div className="form-group" style={{ marginBottom: '1.5rem' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
//                 <label className="form-label" htmlFor="password-input" style={{ margin: 0 }}>Password</label>
//                 <span
//                   style={{ fontSize: '0.75rem', color: 'var(--primary)', cursor: 'pointer', fontWeight: 600 }}
//                   onClick={() => setToast({ message: 'Password recovery email sent. Please check your inbox.', type: 'info' })}
//                 >
//                   Forgot password?
//                 </span>
//               </div>
//               <input
//                 id="password-input"
//                 type="password"
//                 className="form-control"
//                 placeholder="••••••••"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//               />
//             </div>

//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.75rem', fontSize: '0.825rem' }}>
//               <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', color: 'var(--text-secondary)' }}>
//                 <input
//                   type="checkbox"
//                   checked={rememberMe}
//                   onChange={(e) => setRememberMe(e.target.checked)}
//                   style={{ width: '15px', height: '15px', borderRadius: '4px', border: '1px solid var(--border-color)', cursor: 'pointer' }}
//                 />
//                 Remember me
//               </label>
//             </div>

//             <button
//               type="submit"
//               className="btn btn-primary"
//               style={{ width: '100%', padding: '0.75rem', display: 'flex', justifyContent: 'center' }}
//               disabled={loading}
//             >
//               {loading ? 'Signing in...' : 'Sign In'}
//             </button>
//           </form>

//           <div style={{ marginTop: '2rem', borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', textAlign: 'center', fontSize: '0.75rem', color: 'var(--text-tertiary)' }}>
//             <p>Protected System Access Node.</p>
//             <p style={{ marginTop: '0.25rem' }}>Unauthorized login attempts are audited and logged.</p>
//           </div>
//         </div>
//       </div>

//       {toast && (
//         <div className="toast-container">
//           <NotificationToast
//             message={toast.message}
//             type={toast.type}
//             onClose={() => setToast(null)}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Login;























// src/pages/Login.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import NotificationToast from '../components/NotificationToast';
import { useTheme } from '../contexts/ThemeContext';
import Loader from '../components/Loader';

const Login = ({ onLoginSuccess }) => {
  const { user, login } = useAuth();
  const { setTheme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setToast({ message: 'Please enter both email and password.', type: 'error' });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/EOP_api/api/auth/login', {
        email,
        password
      });

      if (response.data && response.data.token) {
        setTheme('light');
        login(response.data.token, response.data.user);
        setToast({ message: 'Login successful! Redirecting...', type: 'success' });
        if (rememberMe) {
          localStorage.setItem('remembered_email', email);
        } else {
          localStorage.removeItem('remembered_email');
        }
      }
    } catch (err) {
      setToast({
        message: err.response?.data?.error || 'Invalid credentials or connection error.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedEmail = localStorage.getItem('remembered_email');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  return (
    <div data-theme="dark" style={{ display: 'flex', minHeight: '100vh', width: '100vw', backgroundColor: 'var(--bg-primary)', overflow: 'hidden' }}>
      {/* Left side: Premium Image Banner */}
      <div
        style={{
          flex: '1',
          background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.94), rgba(219, 39, 119, 0.85)), url("/onboarding_bg.png") center/cover no-repeat',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '4rem',
          color: '#ffffff',
          position: 'relative',
          overflow: 'hidden'
        }}
        className="login-banner"
      >
        <div style={{ position: 'relative', zIndex: 2, maxWidth: '520px' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '3rem', fontWeight: 800, lineHeight: 1.15, marginBottom: '1.5rem', textShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
            Welcome to the Genesis Tech Engineers!
          </h1>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.6, color: 'rgba(255, 255, 255, 0.95)', textShadow: '0 2px 6px rgba(0,0,0,0.1)', fontWeight: 400 }}>
            Complete your self-onboarding tasks securely using the temporary credentials sent to your welcome email. Set up direct deposits, select benefits, sign tax forms, and register your profile.
          </p>
        </div>
        {/* Soft background light glow overlay */}
        <div style={{ position: 'absolute', bottom: '-20%', right: '-20%', width: '600px', height: '600px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)' }}></div>
      </div>

      {/* Right side: Login Form Card */}
      <div
        style={{
          width: '500px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '3rem 2.5rem',
          backgroundColor: 'var(--bg-secondary)',
          borderLeft: '1px solid var(--border-color)',
          boxShadow: 'var(--shadow-lg)',
          zIndex: 10
        }}
        className="login-form-container"
      >
        <div
          style={{
            width: '100%',
            maxWidth: '360px',
            animation: 'fadeIn var(--transition-normal) forwards'
          }}
        >
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '54px',
                height: '54px',
                borderRadius: 'var(--border-radius-md)',
                background: 'linear-gradient(135deg, var(--primary), var(--accent))',
                color: '#ffffff',
                marginBottom: '1.25rem',
                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.2)'
              }}
            >
              <svg style={{ width: '28px', height: '28px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.75rem', fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text-primary)' }}>GTELINQ</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: '0.25rem' }}>Employee Onboarding Portal</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="email-input">Corporate / Personal Email</label>
              <input
                id="email-input"
                type="email"
                className="form-control"
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                <label className="form-label" htmlFor="password-input" style={{ margin: 0 }}>Password</label>
                <span
                  style={{ fontSize: '0.75rem', color: 'var(--primary)', cursor: 'pointer', fontWeight: 600 }}
                  onClick={() => setToast({ message: 'Password recovery email sent. Please check your inbox.', type: 'info' })}
                >
                  Forgot password?
                </span>
              </div>
              <input
                id="password-input"
                type="password"
                className="form-control"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.75rem', fontSize: '0.825rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', color: 'var(--text-secondary)' }}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  style={{ width: '15px', height: '15px', borderRadius: '4px', border: '1px solid var(--border-color)', cursor: 'pointer' }}
                />
                Remember me
              </label>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', padding: '0.75rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              disabled={loading}
            >
              {loading ? <><Loader inline size="sm" /> Signing in...</> : 'Sign In'}
            </button>
          </form>

          <div style={{ marginTop: '2rem', borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem', textAlign: 'center', fontSize: '0.75rem', color: 'var(--text-tertiary)' }}>
            <p>Protected System Access Node.</p>
            <p style={{ marginTop: '0.25rem' }}>Unauthorized login attempts are audited and logged.</p>
          </div>
        </div>
      </div>

      {toast && (
        <div className="toast-container">
          <NotificationToast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        </div>
      )}
    </div>
  );
};

export default Login;
